export default __webpack_public_path__ + "static/media/Zwergpinguin.cf6f4f2e.jpg";